"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var deliverables_shared_service_1 = require("../deliverables-shared.service");
var deliverable_client_config_1 = require("../../deliverable.client.config");
var model = require("../../models");
var helpers_1 = require("../../helpers");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
var i2 = require("../../deliverable.client.config");
var ProductDefinitionService = /** @class */ (function () {
    /**
     * Initialises a new instance of the ProductDefinitionService /> class.
     * @param http
     * @param config
     */
    function ProductDefinitionService(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * Create New Version Async.
     * @param productDefinitionId
     * @returns An Observable containing the ProductDefinition
     */
    ProductDefinitionService.prototype.CreateNewVersionAsync = function (productDefinitionId) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/productdefinition/" + productDefinitionId + "/createnewversion", null)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Create Async.
     * @param createProductDefinitionRequest
     * @returns An Observable containing the ProductDefinition
     */
    ProductDefinitionService.prototype.CreateAsync = function (createProductDefinitionRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/productdefinition/", createProductDefinitionRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Delete.
     * @param id
     * @returns An Observable containing boolean
     */
    ProductDefinitionService.prototype.DeleteAsync = function (id) {
        return this.http.delete(this.config.DeliverablesApiURL + "/api/productdefinition/" + id)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Get.
     * @param id
     * @returns An Observable containing the ProductDefinition
     */
    ProductDefinitionService.prototype.GetAsync = function (id) {
        return this.http.get(this.config.DeliverablesApiURL + "/api/productdefinition/" + id)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List Stubs Async.
     * @param page
     * @param pageSize
     * @param versionTypeId
     * @returns An Observable containing the model.IPagedList<ProductDefinitionStub>
     */
    ProductDefinitionService.prototype.ListStubsAsync = function (page, pageSize, versionTypeId, productTypeId, moduleId, feedId, tagIds) {
        if (page === void 0) { page = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        var params = new http_1.HttpParams();
        if (page)
            params = params.set('page', page.toString());
        if (pageSize)
            params = params.set('pageSize', pageSize.toString());
        if (versionTypeId)
            params = params.set('versionTypeId', versionTypeId.toString());
        if (productTypeId)
            params = params.set('productTypeId', productTypeId.toString());
        if (moduleId)
            params = params.set('moduleId', moduleId.toString());
        if (feedId)
            params = params.set('feedId', feedId.toString());
        if (tagIds && tagIds.length > 0)
            params = params.set('tagIds', tagIds.join(','));
        return this.http.get(this.config.DeliverablesApiURL + "/api/productdefinition/liststubs", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List Stub Current Versions Async.
     * @returns An Observable containing the Array<ProductDefinitionStub>
     */
    ProductDefinitionService.prototype.ListStubCurrentVersionsAsync = function (productTypeId, moduleId, feedId, tagIds) {
        var params = new http_1.HttpParams();
        if (productTypeId)
            params = params.set('productTypeId', productTypeId.toString());
        if (moduleId)
            params = params.set('moduleId', moduleId.toString());
        if (feedId)
            params = params.set('feedId', feedId.toString());
        if (tagIds && tagIds.length > 0)
            params = params.set('tagIds', tagIds.join(','));
        return this.http.get(this.config.DeliverablesApiURL + "/api/productdefinition/liststubcurrentversions", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List Stub Product Versions Async.
     * @param productId
     * @returns An Observable containing the Array<ProductDefinitionStub>
     */
    ProductDefinitionService.prototype.ListStubProductVersionsAsync = function (productId) {
        return this.http.get(this.config.DeliverablesApiURL + "/api/productdefinition/" + productId + "/liststubproductversions")
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List Async.
     * @param page
     * @param pageSize
     * @param versionTypeId
     * @returns An Observable containing the model.IPagedList<ProductDefinition>
     */
    ProductDefinitionService.prototype.ListAsync = function (page, pageSize, versionTypeId, productTypeId, moduleId, feedId, tagIds) {
        if (page === void 0) { page = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        var params = new http_1.HttpParams();
        if (page)
            params = params.set('page', page.toString());
        if (pageSize)
            params = params.set('pageSize', pageSize.toString());
        if (versionTypeId)
            params = params.set('versionTypeId', versionTypeId.toString());
        if (productTypeId)
            params = params.set('productTypeId', productTypeId.toString());
        if (moduleId)
            params = params.set('moduleId', moduleId.toString());
        if (feedId)
            params = params.set('feedId', feedId.toString());
        if (tagIds && tagIds.length > 0)
            params = params.set('tagIds', tagIds.join(','));
        return this.http.get(this.config.DeliverablesApiURL + "/api/productdefinition/", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List Current Versions Async.
     * @returns An Observable containing the Array<ProductDefinition>
     */
    ProductDefinitionService.prototype.ListCurrentVersionsAsync = function (productTypeId, moduleId, productClassId, feedId, tagIds) {
        var params = new http_1.HttpParams();
        if (productTypeId)
            params = params.set('productTypeId', productTypeId.toString());
        if (moduleId)
            params = params.set('moduleId', moduleId.toString());
        if (productClassId)
            params = params.set('productClassId', productClassId);
        if (feedId != null)
            params = params.set('feedId', feedId.toString());
        if (tagIds && tagIds.length > 0)
            params = params.set('tagIds', tagIds.join(','));
        return this.http.get(this.config.DeliverablesApiURL + "/api/productdefinition/listcurrentversions", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List Product Versions Async.
     * @param productId
     * @returns An Observable containing the Array<ProductDefinition>
     */
    ProductDefinitionService.prototype.ListProductVersionsAsync = function (productId) {
        return this.http.get(this.config.DeliverablesApiURL + "/api/productdefinition/" + productId + "/listproductversions")
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Save Async.
     * @param productDefinition
     * @returns An Observable containing the ProductDefinition
     */
    ProductDefinitionService.prototype.SaveAsync = function (productDefinition) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinition/save", productDefinition)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Update Async.
     * @param amendProductDefinitionRequest
     * @returns An Observable containing the ProductDefinition
     */
    ProductDefinitionService.prototype.UpdateAsync = function (amendProductDefinitionRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinition/", amendProductDefinitionRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Add Product Phase Async.
     * @param addProductPhaseRequest
     * @returns An Observable containing the ProductDefinitionPhase
     */
    ProductDefinitionService.prototype.AddProductPhaseAsync = function (addProductPhaseRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinition/addproductphase", addProductPhaseRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Amend Product Phase Async.
     * @param amendProductPhaseRequest
     * @returns An Observable containing the ProductDefinitionPhase
     */
    ProductDefinitionService.prototype.AmendProductPhaseAsync = function (amendProductPhaseRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinition/amendproductphase", amendProductPhaseRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Remove Product Phase Async.
     * @param removeProductPhaseRequest
     * @returns An Observable containing the ProductDefinition
     */
    ProductDefinitionService.prototype.RemoveProductPhaseAsync = function (removeProductPhaseRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinition/removeproductphase", removeProductPhaseRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Upgrade Phase Async.
     * @param upgradePhaseRequest
     * @returns An Observable containing the ProductDefinitionPhase
     */
    ProductDefinitionService.prototype.UpgradePhaseAsync = function (upgradePhaseRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinition/upgradephase", upgradePhaseRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Add Unit Rule Async.
     * @param addUnitRuleRequest
     * @returns An Observable containing the UnitRangeRule
     */
    ProductDefinitionService.prototype.AddUnitRuleAsync = function (addUnitRuleRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinition/addunitrule", addUnitRuleRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Amend Unit Rule Async.
     * @param amendUnitRuleRequest
     * @returns An Observable containing the UnitRangeRule
     */
    ProductDefinitionService.prototype.AmendUnitRuleAsync = function (amendUnitRuleRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinition/amendunitrule", amendUnitRuleRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Remove Unit Rule Async.
     * @param removeUnitRuleRequest
     * @returns An Observable containing the ProductDefinition
     */
    ProductDefinitionService.prototype.RemoveUnitRuleAsync = function (removeUnitRuleRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinition/removeunitrule", removeUnitRuleRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Add Date Rule Async.
     * @param addDateRuleRequest
     * @returns An Observable containing the DateRangeRule
     */
    ProductDefinitionService.prototype.AddDateRuleAsync = function (addDateRuleRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinition/adddaterule", addDateRuleRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Amend Date Rule Async.
     * @param amendDateRuleRequest
     * @returns An Observable containing the DateRangeRule
     */
    ProductDefinitionService.prototype.AmendDateRuleAsync = function (amendDateRuleRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinition/amenddaterule", amendDateRuleRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Remove Date Rule Async.
     * @param removeDateRuleRequest
     * @returns An Observable containing the ProductDefinition
     */
    ProductDefinitionService.prototype.RemoveDateRuleAsync = function (removeDateRuleRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinition/removedaterule", removeDateRuleRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Create Dummy Deliverable Async.
     * @param productDefinitionId
     * @param createContractRequest
     * @returns An Observable containing the IDeliverableBase
     */
    ProductDefinitionService.prototype.CreateDummyDeliverableAsync = function (productDefinitionId, createContractRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/productdefinition/" + productDefinitionId + "/createdummydeliverable", createContractRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Post Outcome.
     * @param productDefinitionId
     * @param addOutcomeRequest
     * @returns An Observable containing boolean
     */
    ProductDefinitionService.prototype.PostOutcomeAsync = function (productDefinitionId, addOutcomeRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/productdefinition/" + productDefinitionId + "/outcomes", addOutcomeRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Put Outcome.
     * @param productDefinitionId
     * @param outcomeId
     * @param amendOutcomeRequest
     * @returns An Observable containing boolean
     */
    ProductDefinitionService.prototype.PutOutcomeAsync = function (productDefinitionId, outcomeId, amendOutcomeRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinition/" + productDefinitionId + "/outcomes/" + outcomeId, amendOutcomeRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Delete Outcome.
     * @param productDefinitionId
     * @param outcomeId
     * @returns An Observable containing boolean
     */
    ProductDefinitionService.prototype.DeleteOutcomeAsync = function (productDefinitionId, outcomeId) {
        return this.http.delete(this.config.DeliverablesApiURL + "/api/productdefinition/" + productDefinitionId + "/outcomes/" + outcomeId)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * Post Role.
   * @param productDefinitionId
   * @param addProductRoleRequest
   * @returns An Observable containing ProductDefinition
   */
    ProductDefinitionService.prototype.PostRoleAsync = function (productDefinitionId, addProductRoleRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/productdefinition/" + productDefinitionId + "/roles", addProductRoleRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
  * Delete Role.
  * @param productDefinitionId
  * @param roleId
  * @returns An Observable containing ProductDefinition
  */
    ProductDefinitionService.prototype.DeleteRoleAsync = function (productDefinitionId, roleId) {
        return this.http.delete(this.config.DeliverablesApiURL + "/api/productdefinition/" + productDefinitionId + "/roles/" + roleId)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * Post Role.
   * @param productDefinitionId
   * @param addProductRoleRequest
   * @returns An Observable containing ProductDefinition
   */
    ProductDefinitionService.prototype.AddProductClassAsync = function (productDefinitionId, productClassId) {
        var request = new model.AddProductClassRequest();
        request.productDefinitionId = productDefinitionId;
        request.productClassId = productClassId;
        return this.http.post(this.config.DeliverablesApiURL + "/api/productdefinition/" + productDefinitionId + "/classes", request)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
  * Post Role.
  * @param productDefinitionId
  * @param tagId
  * @returns An Observable containing ProductDefinition
  */
    ProductDefinitionService.prototype.AddTagAsync = function (productDefinitionId, tagId, phaseId) {
        var request = new model.UpdateTagRequest();
        request.tagId = tagId;
        if (!phaseId) {
            return this.http.post(this.config.DeliverablesApiURL + "/api/productdefinition/" + productDefinitionId + "/addtag", request)
                .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
        }
        else {
            return this.http.post(this.config.DeliverablesApiURL + "/api/productdefinition/" + productDefinitionId + "/phases/" + phaseId + "/addtag", request)
                .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
        }
    };
    /**
      * Make a copy of product definition .
      * @param productDefinitionId
      * @param name
      * @returns An Observable containing boolean
      */
    ProductDefinitionService.prototype.MakeACopyAsync = function (productDefinitionId, name) {
        var request = new model.DuplicateProductDefinitionRequest();
        request.name = name;
        return this.http.post(this.config.DeliverablesApiURL + "/api/productdefinition/" + productDefinitionId + "/makeacopy", request)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
  * Post Role.
  * @param productDefinitionId
  * @param tagId
  * @returns An Observable containing ProductDefinition
  */
    ProductDefinitionService.prototype.RemoveTagAsync = function (productDefinitionId, tagId, phaseId) {
        var request = new model.UpdateTagRequest();
        request.tagId = tagId;
        if (!phaseId) {
            return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinition/" + productDefinitionId + "/removetag", request)
                .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
        }
        else
            return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinition/" + productDefinitionId + "/phases/" + phaseId + "/removetag", request)
                .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    ProductDefinitionService.ngInjectableDef = i0.defineInjectable({ factory: function ProductDefinitionService_Factory() { return new ProductDefinitionService(i0.inject(i1.HttpClient), i0.inject(i2.DELIVERABLE_CLIENT_CONFIG)); }, token: ProductDefinitionService, providedIn: "root" });
    ProductDefinitionService = __decorate([ __param(1, core_1.Inject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], ProductDefinitionService);
ProductDefinitionService.ɵfac = function ProductDefinitionService_Factory(t) { return new (t || ProductDefinitionService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)); };
ProductDefinitionService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ProductDefinitionService, factory: function (t) { return ProductDefinitionService.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProductDefinitionService, [{
        type: core_1.Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG]
            }] }]; }, null); })();
    return ProductDefinitionService;
}());
exports.ProductDefinitionService = ProductDefinitionService;

